// extracted by mini-css-extract-plugin
module.exports = {"title":"GpPr33_4"};